"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SvgIcon = _interopRequireDefault(require("./SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PeoplePlus = function PeoplePlus(_ref) {
  var size = _ref.size,
      color = _ref.color,
      secondaryColor = _ref.secondaryColor;
  return _react["default"].createElement(_SvgIcon["default"], {
    title: "people-plus",
    size: size
  }, _react["default"].createElement("path", {
    fill: secondaryColor,
    d: "M4 4a2 2 0 012 2v2H5V6a1 1 0 10-2 0v2H2V6c0-1.1.9-2 2-2zm2.5 0C7.33 4 8 4.67 8 5.5V7h-.75V5.5a.75.75 0 00-.99-.71c-.1-.24-.23-.46-.4-.65.2-.09.41-.14.64-.14zm-5 0c.23 0 .44.05.63.14-.16.2-.3.41-.4.65a.75.75 0 00-.98.71V7H0V5.5C0 4.67.67 4 1.5 4zM8 2.49v.01a1.5 1.5 0 01-2.26 1.3l.17-.19c.13.09.3.14.46.14.45 0 .82-.33.87-.77l.01-.1v-.13h.13c.24 0 .46-.1.62-.26zM1.5 1l.2.01c-.1.23-.16.48-.19.74H1.5a.75.75 0 10.3 1.44c.12.21.26.41.44.58l.02.02A1.5 1.5 0 111.5 1zM4 0a2 2 0 011.52.7L5.5.77l-.01.1V1h-.13c-.26 0-.5.12-.66.3a1 1 0 10.12 1.26c.12.1.26.16.42.18l.13.01h.12v.13c0 .12.03.24.08.35A2 2 0 114 0zm2.5 1v.75h.88a.13.13 0 01.03.24L7.37 2h-.31a.75.75 0 00-.45-.24h-.12c-.03-.27-.1-.52-.2-.75L6.5 1z"
  }), _react["default"].createElement("path", {
    fill: color,
    d: "M6.4.4c.28 0 .5.22.5.5v.5h.5a.5.5 0 010 1h-.5v.5a.5.5 0 01-1 0v-.5h-.5a.5.5 0 010-1h.5V.9c0-.28.22-.5.5-.5z"
  }));
};

PeoplePlus.defaultProps = {
  size: 8,
  color: '#444',
  secondaryColor: '#444'
};
var _default = PeoplePlus;
exports["default"] = _default;